const COLOR_CLASSES = {
  blue: 'bg-blue-50 text-blue-700',
  purple: 'bg-purple-50 text-purple-700',
  green: 'bg-green-50 text-green-700',
  orange: 'bg-brand-50 text-brand-600',
  grey: 'bg-grey-100 text-grey-700',
  yellow: 'bg-yellow-50 text-yellow-800'
};

const GlossaryCategoryTag = ({ name, color = 'grey', className = '' }) => {
  const colorClass = COLOR_CLASSES[color] || COLOR_CLASSES.grey;

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${colorClass} ${className}`.trim()}
    >
      {name}
    </span>
  );
};

export default GlossaryCategoryTag;
